import { render, staticRenderFns } from "./AndOR.vue?vue&type=template&id=f087a0a2&"
import script from "./AndOR.vue?vue&type=script&lang=js&"
export * from "./AndOR.vue?vue&type=script&lang=js&"
import style0 from "./AndOR.vue?vue&type=style&index=0&id=f087a0a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports